import { api } from '../../../services/api';
import { dateService } from '../../../services/date';

class SmartlinkService {
	constructor() {
		this.Api = api;

		this.channelFields = [
			{label: 'Site', selected: false},
			{label: 'Newsletter', selected: false},
			{label: 'Facebook', selected: false},
			{label: 'Instagram', selected: false},
			{label: 'YouTube', selected: false},
			{label: 'Other', selected: false},
		];
		this.stockStatusFields = [
			{label: 'Feed status', value: null, selected: false},
			{label: 'In stock', value: true, selected: false},
			{label: 'Out of stock', value: false, selected: false},
		];
		this.auctionStatusFields = [
			{label: 'Exclusive', value: true, selected: false},
			{label: 'Active', value: null, selected: false},
			{label: 'Disabled', value: false, selected: false},
		];

		const currentDate = dateService.getCurrentDateTime();
		this.expirationPresets = [
			{label: '1 day', value: this.getDate(currentDate, 1, 'day'), selected: false},
			{label: '2 days', value: this.getDate(currentDate, 2, 'days'), selected: false},
			{label: '1 week', value: this.getDate(currentDate, 1, 'week'), selected: false},
			{label: '1 month', value: this.getDate(currentDate, 1, 'month'), selected: false},
		];

		// Matches price formats (integers or two decimal floats)
		this.priceRegex = /^[0-9]\d{0,2}(?:,?\d{3})*(?:\.\d{2})?$/;

		this.auctionConfigFormat = {
			is_in_stock: {
				value: null,
				ttl_expiration: null,
			},
			participate_in_auction: {
				value: null,
				ttl_expiration: null,
			},
			sale_price: {
				value: null,
				ttl_expiration: null,
			},
		};
	}

	querySmartlinkSummary(smartlinkId) {
		const endpoint = `/api/v1/product_match/bam_links/${smartlinkId}/management/`;
		return this.Api.get(endpoint).then((resp) => {
			return Promise.resolve(resp.data.data[0]);
		});
	}

	queryAuctionPreview(auctionId) {
		const endpoint = `/api/v1/auction_preview/`;
		const params = {'a': auctionId};
		return this.Api.get(endpoint, params).then((resp) => {
			return Promise.resolve(resp.data.data[0].auction);
		});
	}

	updateSmartlinkSummary(smartlinkId, data) {
		const endpoint = `/api/v1/product_match/bam_links/${smartlinkId}/management/`;
		return this.Api.put(endpoint, data);
		// TODO: add error modal () => onError(),
	}

	validateSmartlink(data) {
		const {error, productErrors} = this.validateProducts(data.merchant_products);
		const nameLength = data.edit.name.length;
		const nameError = !nameLength || nameLength > 100;

		if (error || nameError) {
			return Promise.reject({productErrors, nameError});
		} else {
			return Promise.resolve();
		}
	}

	getDefaultStockFields(isInStock, partialFields=false) {
		const fields = partialFields ? partialFields : this.stockStatusFields;

		return fields.map((field) => {
			field.selected = field.value === isInStock;
			return field;
		});
	}

	getDefaultAuctionFields(participateInAuction) {
		return this.auctionStatusFields.map((field) => {
			field.selected = field.value === participateInAuction;
			return field;
		});
	}

	getDate(currentDate, offset, unit) {
		return dateService.formatDate(
			dateService.offsetFromDate(currentDate, offset, unit), 'MM/DD/YY'
		);
	}

	getLabel(items, key='label') {
		return items.find((item) => item.selected)[key];
	}
}

export default new SmartlinkService();
